"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var OffIcon = function OffIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.0002 17.5C13.676 17.5 16.6668 14.5091 16.6668 10.8333C16.6668 8.04164 14.9402 5.64914 12.5002 4.65747V6.50997C13.9918 7.37664 15.0002 8.98747 15.0002 10.8333C15.0002 13.5908 12.7577 15.8333 10.0002 15.8333C7.24266 15.8333 5.00016 13.5908 5.00016 10.8333C5.00016 8.98747 6.0085 7.3758 7.50016 6.50997V4.65747C5.06016 5.64914 3.3335 8.04164 3.3335 10.8333C3.3335 14.5091 6.32433 17.5 10.0002 17.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 4C9 3.44772 9.44772 3 10 3C10.5523 3 11 3.44772 11 4V8C11 8.55228 10.5523 9 10 9C9.44772 9 9 8.55228 9 8V4Z",
    fill: color
  }));
};
var _default = OffIcon;
exports.default = _default;